import { APP_STORE_URL, RECONVERT_IO_URL } from '../config';

const handleRedirect = () => {
  console.log(
    'redirecting to',
    `${RECONVERT_IO_URL}?utm_source=admin-preview&utm_medium=admin-preview&utm_campaign=admin-preview&utm_id=review-collector`
  );

  // Get reference to opened window
  const newWindow = window.open(
    `${RECONVERT_IO_URL}?utm_source=admin-preview&utm_medium=admin-preview&utm_campaign=admin-preview&utm_id=review-collector`,
    '_blank'
  );

  // Wait a moment for the page to load, then redirect
  setTimeout(() => {
    try {
        if(newWindow) {
      newWindow.location.href = `${APP_STORE_URL}#modal-show=WriteReviewModal?utm_source=admin-preview&utm_medium=admin-preview&utm_campaign=admin-preview&utm_id=review-collector`;
        }
      // or
      // newWindow.location.replace("https://your-final-destination.com");
    } catch (error) {
      console.log('Cannot redirect due to same-origin policy:', error);
    }
  }, 300);
};


export const redirect = async () => {

  if (window?.shopify) {

    try {
      const result = await window.shopify.reviews.request();
      
      if (!result.success) {

        console.log(
          `Review modal not displayed. Reason: ${result.code}: ${result.message}`
        );
        handleRedirect();

        return false;
      }

      return true;
      // if result.success *is* true, then review modal is displayed
    } catch (error) {
      console.error('Error requesting review:', error);
      handleRedirect();

      return false;
    }
  } else {
    handleRedirect();

    return false;
  }
};
